module.exports = __webpack_public_path__ + "img/40.22f0476d.jpg";